import { render } from "./ListSideMarginAdjuster.vue?vue&type=template&id=619b7c5a"
import script from "./ListSideMarginAdjuster.vue?vue&type=script&lang=js"
export * from "./ListSideMarginAdjuster.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__